import * as Scrivito from "scrivito"
import { NotificationType } from "shared/context/NotificationContext"
import { AppActionType } from "shared/types/AppAction"
import { EDITOR_ICONS } from "shared/ui/icon/EditorIcons"

export const LinkListActionWidget = Scrivito.provideWidgetClass(
  "LinkListActionWidget",
  {
    attributes: {
      title: "string",
      icon: ["enum", { values: EDITOR_ICONS }],
      action: ["enum", { values: Object.values(AppActionType) }],
      notificationType: [
        "enum",
        { values: ["none", ...Object.values(NotificationType)] }
      ],
      hideForUnauthenticatedUsers: "boolean",
      hideTooltip: "boolean"
    }
  }
)
